import { MetricWeightUnit, WeightOrder } from '@/models/interfaces/metric'
import { $factor } from './'
import Unit from './unit'


export default class Weight extends Unit<MetricWeightUnit> {
  constructor (value: number | string | Weight, unit = MetricWeightUnit.Gram) {
    super(value instanceof Weight ? value.value : value, unit || MetricWeightUnit.Gram, Weight.validateUnit)
  }

  /**
   * @param unit the unit to be converted to
   */
  to (unit: MetricWeightUnit) {
    return Weight.to(this.value, unit)
  }

  /**
   * @param unit the unit to be converted to
   */
  static to (value: number | string, unit = MetricWeightUnit.Gram) {
    const parsed = Weight.parse(value, unit)
    if (!parsed) throw Error(`Failed to parse value "${value}" as weight`)

    const direction = WeightOrder.indexOf(parsed.unit) - WeightOrder.indexOf(unit)

    if (direction === 0) return new Weight(parsed.value, parsed.unit)
    return direction > 0 // > = higher order
      ? new Weight(parsed.value / ($factor(1, direction)), parsed.unit)
      : new Weight(parsed.value * ($factor(1, direction)), parsed.unit)
  }

  static validateUnit (unit: MetricWeightUnit | string) {
    return Object.values(MetricWeightUnit).includes(unit as any)
  }
}
